import React from 'react';
import { motion } from 'framer-motion';
import { FlameIcon } from 'lucide-react';
import { TOTAL_SPOTS, useSpotsLeft } from '../hooks/useOfferTimer';
type ScarcityBarProps = {
  dark?: boolean;
};
export function ScarcityBar({
  dark = false
}: ScarcityBarProps) {
  const spots = useSpotsLeft();
  const filled = Math.round((TOTAL_SPOTS - spots) / TOTAL_SPOTS * 100);
  return <div className={`rounded-2xl p-4 ${dark ? 'bg-white/5 ring-1 ring-white/15' : 'bg-paper ring-1 ring-ink/10'}`} data-id="element-48" data-mp="2b703u4gie7s3">
      <div className="flex items-center justify-between gap-3" data-id="element-49" data-mp="2g63b7vjyoq38">
        <p className={`flex items-center gap-2 text-[15px] font-bold leading-snug ${dark ? 'text-white' : 'text-ink'}`} data-id="element-50" data-mp="2g3gvv9qtx6ag">
          <FlameIcon className="h-5 w-5 shrink-0 text-alert" aria-hidden="true" data-id="element-51" data-mp="274n01llbojxy" />
          <span data-id="element-52" data-mp="ep6ludgtgta">
            Only <span className="text-alert" data-id="element-53" data-mp="e5ly5wfkebk">{spots} spots</span> left at the promotional price
          </span>
        </p>
        <span className={`shrink-0 text-sm font-extrabold tabular-nums ${dark ? 'text-cta' : 'text-alert'}`} data-id="element-54" data-mp="5cqquimmnm6c">{filled}%</span>
      </div>
      <div className={`mt-3 h-4 w-full overflow-hidden rounded-full ${dark ? 'bg-white/10' : 'bg-ink/10'}`} role="progressbar" aria-valuenow={filled} aria-valuemin={0} aria-valuemax={100} aria-label="Promotional spots claimed" data-id="element-55" data-mp="33ks6f5vwfzmr">
        <motion.div className="h-full rounded-full bg-alert" initial={{
        width: '70%'
      }} whileInView={{
        width: `${filled}%`
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.9,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-56" data-mp="38e4t3ah0pwcv" />
      </div>
      <p className={`mt-2 text-xs font-medium ${dark ? 'text-white/60' : 'text-ink/55'}`} data-id="element-57" data-mp="2umzri2u3atzw">
        When the promotional spots run out, the price returns to the regular value.
      </p>
    </div>;
}